import axios from 'axios';

import createUrlWithParams from 'helpers/createUrlWithParams';

import { parseDashboardKpiForFE, parseTemplateDashboardInstanceLinksForFE, parseTemplatesDashboardForFE } from './statistics.parsers';
import type {
  DashboardKPI,
  StatisticsApi,
  TemplateDashboardInstanceLink,
  TemplateDashboardInstanceLinkDTO,
  TemplatesDashboard,
  TemplatesDashboardDTO,
  TemplatesDashboardInstancesQueryParams,
  TemplatesDashboardListResponseDTO,
  TemplatesDashboardQueryParams,
} from './statistics.types';

const baseUrl = 'api/v1/statistics/';

const statisticsApi: StatisticsApi = {
  getAssetActionsDashboardKpi: async rawParams => {
    const { data } = await axios.get(createUrlWithParams(`${baseUrl}dashboard/`, rawParams));
    return parseDashboardKpiForFE(data);
  },

  getTemplatesDashboard: async rawParams => {
    const { data } = await axios.get<unknown>(createUrlWithParams(`${baseUrl}templates-dashboard/`, rawParams));
    return parseTemplatesDashboardForFE(data);
  },

  getTemplatesDashboardInstances: async rawParams => {
    const { data } = await axios.get<TemplateDashboardInstanceLinkDTO[]>(
      createUrlWithParams(`${baseUrl}templates-dashboard-instances/`, rawParams),
    );
    return parseTemplateDashboardInstanceLinksForFE(data);
  },
};

export type {
  DashboardKPI,
  TemplateDashboardInstanceLink,
  TemplatesDashboard,
  TemplatesDashboardDTO,
  TemplatesDashboardInstancesQueryParams,
  TemplatesDashboardListResponseDTO,
  TemplatesDashboardQueryParams,
};

export default statisticsApi;
